import { motion } from 'framer-motion';

export default function MapSection() {
  return (
    <section id="map" className="relative pt-8 pb-20 md:pt-10 md:pb-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="rounded-2xl overflow-hidden shadow-xl"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <div className="w-full aspect-[16/9] md:aspect-[21/9]">
            <iframe
              title="Ubicación Finca Los Sauces"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3925.405!2d-83.85!3d9.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0d4e123456789%3A0xabcdef1234567890!2sCaba%C3%B1a%20Finca%20Los%20Sauces%2C%20Cartago%2C%20Costa%20Rica!5e0!3m2!1ses!2scr!4v1700000000000!5m2!1ses!2scr"
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
